namespace Gamification.Gamification {
    export interface TipologieEsperienzeRow {
        IdTipologiaEsperienza?: number;
        Nome?: string;
        Descrizione?: string;
    }

    export namespace TipologieEsperienzeRow {
        export const idProperty = 'IdTipologiaEsperienza';
        export const nameProperty = 'Nome';
        export const localTextPrefix = 'Gamification.TipologieEsperienze';
        export const lookupKey = 'Gamification.TipologieEsperienze';

        export function getLookup(): Q.Lookup<TipologieEsperienzeRow> {
            return Q.getLookup<TipologieEsperienzeRow>('Gamification.TipologieEsperienze');
        }
        export const deletePermission = 'Role:SuperAdmin';
        export const insertPermission = 'Role:SuperAdmin';
        export const readPermission = 'Gamification:Configurazione:View';
        export const updatePermission = 'Role:SuperAdmin';

        export declare const enum Fields {
            IdTipologiaEsperienza = "IdTipologiaEsperienza",
            Nome = "Nome",
            Descrizione = "Descrizione"
        }
    }
}
